import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import ReactSelect from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import Grid from "@material-ui/core/Grid";

import Header from "../../components/Header";
import Firebase from "../../firebasehelper";

import "./index.css";

const TransactionalLedger = () => {
  const [loading, setLoading] = useState(false);
  const [brandData, setBrandData] = useState({});
  const [brand, setBrand] = useState(null);
  const [role, setRole] = useState(null);
  const [username, setUserName] = useState("");

  const [brandList, setBrandList] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState({
    label: "All",
    value: "All",
  });

  const [transationList, setTransactionList] = useState([]);

  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    if (!location.state) {
      history.push("/");
    } else {
      const { brand, role, username } = location.state;
      setRole(role);
      setBrand(brand);
      setUserName(username);
      setLoading(true);

      function loadBrands() {
        Firebase.getAllBrandsOnce((allBrands) => {
          setBrandList(allBrands);
          const promises = allBrands
            .filter((b) => b.name === "Vet Coin")
            .map(async (brand) => {
              const users = await Firebase.getAllUsersInBrand(brand.name);
              const promises = users.map(async (user) => {
                const token_history =
                  await Firebase.getTokenSpentHistoryPromise(
                    brand.name,
                    user.id
                  );
                const premier_history = await Firebase.getPremierTokensHistory(
                  brand.name,
                  user.id
                );

                const history = [
                  ...token_history.map((h) => ({
                    ...h,
                    tokenType: "shopping",
                    brand: brand.name,
                    uid: user.id,
                  })),
                  ...premier_history.map((p) => ({
                    ...p,
                    tokenType: "premier",
                    brand: brand.name,
                    uid: user.id,
                  })),
                ];

                return history;
              });
              const histories = await Promise.all(promises);
              return histories;
            });
          Promise.all(promises).then((res) => {
            const combinedHistories = res
              .map((values) => values.reduce((c, v) => c.concat(v), []))
              .reduce((c, v) => c.concat(v), [])
              .sort((a, b) => b.created.seconds - a.created.seconds);
            console.log("combined", combinedHistories);
            setTransactionList(combinedHistories);
            setLoading(false);
          });
        });
      }
      loadBrands();
    }
  }, [location]);

  useEffect(() => {}, [selectedBrand]);

  return (
    <div id="page-container">
      {loading && (
        <div className="loading_gif">
          <i className="fa fa-4x fa-sync fa-spin text-muted" />
        </div>
      )}
      <Header
        username={username}
        role={role}
        logo={brandData.logo}
        brand={brand}
        brandName={brandData.name}
        is_property_brand={brandData.is_property_brand}
      />
      <div className="transactional-ledger-content">
        <div className="content-header">
          <div className="form-group flex-row col-3">
            <p className="form-label">Brand</p>
            <div className="full-width">
              <ReactSelect
                value={selectedBrand}
                options={[{ label: "All", value: "All" }].concat(
                  brandList.map((brand) => ({
                    label: brand.name,
                    value: brand.id,
                  }))
                )}
                onChange={(selected) => setSelectedBrand(selected)}
                placeholder="Select Brand"
              ></ReactSelect>
            </div>
          </div>
          <div className="form-group flex-row">
            <p className="form-label">User</p>
            <div className="search-box">
              <input
                placeholder="Search by name or UID"
                type="text"
                value=""
                onChange={({ target }) => {}}
                name="search"
                autoComplete="off"
                aria-autocomplete="none"
              />
              <button onClick={() => {}}>
                <i className="fa fa-search" />
              </button>
            </div>
          </div>
          <div className="form-group flex-row col-5">
            <p className="form-label">Export</p>
            <div className="date-form flex-row">
              <p
                style={{
                  fontSize: "12px",
                  marginRight: "5px",
                  fontWeight: "normal",
                }}
              >
                Start
              </p>
              <DatePicker selected={new Date()} onChange={(date) => {}} />
            </div>
            <div className="date-form flex-row">
              <p
                style={{
                  fontSize: "12px",
                  marginRight: "5px",
                  fontWeight: "normal",
                }}
              >
                End
              </p>
              <DatePicker selected={new Date()} onChange={(date) => {}} />
            </div>
            <button className="btn btn-white">Export</button>
          </div>
        </div>
        <div className="transaction-table">
          <div className="table-header">
            <Grid container spacing={3}>
              <Grid item xs={2}>
                <p>Transaction time</p>
              </Grid>
              <Grid item xs={2}>
                <p>Item</p>
              </Grid>
              <Grid item xs={2}>
                <p>Fiat Value</p>
              </Grid>
              <Grid item xs={1}>
                <p>Form</p>
              </Grid>
              <Grid item xs={2}>
                <p>UID</p>
              </Grid>
              <Grid item xs={2}>
                <p>User transactions</p>
              </Grid>
            </Grid>
          </div>
          <div className="table-content">
            {transationList.map((transaction, index) => (
              <div key={index} className="transaction-row">
                <Grid container spacing={3}>
                  <Grid item xs={2} className="flex-row align-center">
                    <p className="member-name">
                      {moment.unix(transaction.created.seconds).calendar(null, {
                        sameDay: "[Today]",
                        nextDay: "[Tomorrow]",
                        nextWeek: "dddd",
                        lastDay: "[Yesterday]",
                        lastWeek: "[Last] dddd",
                        sameElse: "HH:MM \xa0\xa0\xa0 DD.MM.YYYY",
                      })}
                    </p>
                  </Grid>
                  <Grid item xs={2} className="flex-row align-center">
                    <p style={{ marginRight: "5px" }}>{`${
                      transaction.amount > 0 ? "-" : "+"
                    }`}</p>
                    <p>{`${transaction.type}`}</p>
                  </Grid>
                  <Grid item xs={2} className="flex-row align-center">
                    <p>{`${transaction.amount > 0 ? "-" : "+"} ${Math.abs(
                      transaction.amount / 100
                    ).toFixed(2)}`}</p>
                  </Grid>
                  <Grid item xs={1} className="flex-row align-center">
                    <p>
                      {transaction.tokenType === "shopping"
                        ? "Shopping"
                        : "Premier"}
                    </p>
                  </Grid>
                  <Grid item xs={2} className="flex-row align-center">
                    <p>{transaction.uid}</p>
                  </Grid>
                  <Grid item xs={2} className="flex-row align-center">
                    <button className="btn btn-white">View Ledger</button>
                  </Grid>
                </Grid>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TransactionalLedger;



// WEBPACK FOOTER //
// ./src/screens/TransactionalLedger/index.js